import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL } from "@utils/utilsApi";
import { EditionItem } from "../types";

interface UseEditionsListArgs {
  corporateId: string | number;
  objectId: number;
  page: number;
  pageSize: number;
  search?: string;
  sort?: string | null;
  fieldFilters?: Record<string, any>;
}

export const useEditionsList = ({
  corporateId,
  objectId,
  page,
  pageSize,
  search,
  sort,
  fieldFilters,
}: UseEditionsListArgs): PaginatedListResult<EditionItem> => {
  const url = corporateId
    ? `${ServicesURL.getEditions}?corporateId=${corporateId}&learning_objects_id=${objectId}`
    : null;

  return usePaginatedList<EditionItem>(url, {
    page,
    pageSize,
    search,
    sort,
    fieldFilters,
  });
};
